import { render, staticRenderFns } from "./EditGlobalCivilization.vue?vue&type=template&id=aee5a07e&scoped=true&"
import script from "./EditGlobalCivilization.vue?vue&type=script&lang=js&"
export * from "./EditGlobalCivilization.vue?vue&type=script&lang=js&"
import style0 from "./EditGlobalCivilization.vue?vue&type=style&index=0&id=aee5a07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee5a07e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VDataTable,VIcon,VRow,VTextField,VTooltip})
